module.exports = __webpack_public_path__ + "img/logo-3.b3b035c4.png";